// 載入骨架（B-29、P1-1「全站載入改骨架」）：開頁與重新整理不再整頁黑、數字不先顯示 0 再跳。
// 純畫面，不讀任何 context（main.tsx 在設定 / 登入還沒好之前就要畫）。

export function SkeletonLines({ n = 3, label }: { n?: number; label?: string }) {
  return (
    <div className="skeleton-lines" aria-busy="true" aria-label={label}>
      {Array.from({ length: n }, (_, i) => (
        <div key={i} className="skeleton-bar" style={{ width: `${90 - ((i * 17) % 40)}%` }} />
      ))}
    </div>
  );
}

/** 頁面主區：標題列 + 三張卡片的灰塊。 */
export function PageSkeleton({ label }: { label?: string }) {
  return (
    <div className="page-skeleton" aria-busy="true" aria-label={label} data-testid="page-skeleton">
      <div className="skeleton-bar skeleton-title" />
      <div className="skeleton-cards">
        {[0, 1, 2].map((i) => (
          <div key={i} className="card skeleton-block" />
        ))}
      </div>
      <div className="card skeleton-block skeleton-wide" />
    </div>
  );
}

/** 啟動中（設定、品牌、登入狀態還在問）：殼層的樣子先畫出來。 */
export function BootSkeleton() {
  return (
    <div className="shell" data-testid="boot-skeleton">
      <header className="topbar">
        <div className="skeleton-bar" style={{ width: 160 }} />
      </header>
      <nav className="sidenav" aria-hidden="true">
        <SkeletonLines n={8} />
      </nav>
      <main className="main">
        <PageSkeleton />
      </main>
    </div>
  );
}
